import { maybe, Maybe } from '@passionware/monads';

export interface TotalHeaderProps {
  total: Maybe<string>;
}

export const TotalHeader = ({ total }: TotalHeaderProps) => {
  return (
    <div className="flex flex-row gap-2 self-center h-full items-center px-2 ">
      {maybe.map(total, total => (
        <>
          <div>Total</div>
          <div className="ml-auto font-semibold">{total}</div>
        </>
      ))}
    </div>
  );
};
